import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import styled from 'styled-components';
import React from 'react';

type Props = {
  className?: string;
  onChange?: (event: CheckboxChangeEvent) => void;
  checked?: boolean | null;
  value?: string | number | string[] | boolean | null;
  isDisabled?: boolean;
  label?: string;
  labelClass?: string;
  name?: string;
  type?: 'circle' | 'box-selector' | 'box-filler';
};

export const CheckBoxWithLabel = ({
  className,
  onChange,
  checked,
  value,
  isDisabled,
  label,
  name,
  labelClass,
  type = 'box-selector',
}: Props) => {
  return (
    <StyledDiv className={`${className}`}>
      <label
        className={`${labelClass ?? ''} check-label ${
          isDisabled ? 'disabled-checkbox' : ''
        }`}
      >
        <Checkbox
          onChange={onChange}
          checked={checked}
          value={value}
          disabled={isDisabled}
          name={name}
          className={`custom-check-box ${type}`}
        />
        {label}
      </label>
    </StyledDiv>
  );
};

const StyledDiv = styled.div`
  .disabled-checkbox {
    cursor: not-allowed;
  }
  display: flex;
  align-items: center;
  gap: 7px;

  .custom-check-box {
    display: flex;

    &.circle {
      .k-checkbox {
        border-radius: 50%;
      }
    }
    &.box-filler {
      input[type='checkbox']:checked {
        background-image: none !important;
        background-color: ${p => p.theme.checkBoxBackGroundColor} !important;
        border: 1.7px solid white;
        box-shadow: 0 0 0 0.5px ${p => p.theme.checkBoxBackGroundColor} !important;
      }
    }
  }

  label {
    padding-left: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    line-height: 24px;
    font-size: 16px;
    font-family: 'Open Sans';
    user-select: none;

    @media (max-width: 768px) {
      font-size: 10.67px;
    }
    @media (min-width: 769px) and (max-width: 991px) {
      font-size: 11px;
    }
    @media (min-width: 992px) and (max-width: 1023px) {
      font-size: 11.36px;
    }
    @media (min-width: 1024px) and (max-width: 1279px) {
      font-size: 14.22px;
    }
    @media (min-width: 1280px) and (max-width: 1365px) {
      font-size: 15.16px;
    }
    @media (min-width: 1366px) and (max-width: 1439px) {
      font-size: 15.99px;
    }
    @media (min-width: 1440px) and (max-width: 1600px) {
      font-size: 17.78px;
    }
    @media (min-width: 1601px) and (max-width: 1799px) {
      font-size: 19.99px;
    }
  }
  display: flex;
  align-items: baseline;
  margin: 5px 0;
  .k-checkbox {
    background-color: transparent !important;
    border: 1px solid ${p => p.theme.checkBoxBorderColor};
  }
  .k-checkbox-wrap {
    padding-right: 5px !important;
  }

  .k-checkbox:focus {
    box-shadow: none !important;
  }
  &:focus {
    outline-style: none;
    box-shadow: none;
    border-color: ${p => p.theme.checkBoxFocusBorderColor};
  }

  input[type='checkbox'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    border: 1px solid ${p => p.theme.checkBoxBorderColor};
    border-radius: 2px;
    outline: none;
    transition: border-color 0.3s;
    cursor: pointer;
    @media (max-width: 768px) {
      width: 13px;
      height: 13px;
      border-radius: 3px;
    }
    @media (min-width: 769px) and (max-width: 991px) {
      width: 13px;
      height: 13px;
      border-radius: 3px;
    }
    @media (min-width: 992px) and (max-width: 1023px) {
      width: 14px;
      height: 14px;
      border-radius: 3px;
    }
    @media (min-width: 1024px) and (max-width: 1279px) {
      width: 16px;
      height: 16px;
      border-radius: 3px;
    }
    @media (min-width: 1280px) and (max-width: 1365px) {
      width: 16px;
      height: 16px;
    }
    @media (min-width: 1366px) and (max-width: 1439px) {
      width: 17px;
      height: 17px;
    }
    @media (min-width: 1440px) and (max-width: 1600px) {
      width: 17px;
      height: 17px;
    }
    @media (min-width: 1601px) and (max-width: 1799px) {
      width: 20px;
      height: 20px;
    }
  }

  .k-checkbox:checked,
  .k-checkbox.k-checked {
    background-color: ${p => p.theme.checkBoxCheckBorderColor} !important;
    border: 1px solid transparent;
  }

  input[type='checkbox']:checked {
    background-color: ${p => p.theme.checkBoxCheckBorderColor} !important;
  }

  input[type='checkbox']:checked::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
    width: 9px;
    height: 5px;
    border: none;
    margin: 0;
  }
`;
